import { createReduxEssentials } from '@helpers/createReduxEssentials'

import { GLOBAL_STATE, actionNames } from '../constants/actionTypes'

const { actions, actionTypes, selectors, reducer } = createReduxEssentials(actionNames, GLOBAL_STATE)

export const E_LIBRARY = GLOBAL_STATE

export { reducer, actionTypes, actions, selectors }
